/* eslint global-require: 0 */
module.exports = require('./ReactSixteenAdapter');


//////////////////
// WEBPACK FOOTER
// ./~/enzyme-adapter-react-16/build/index.js
// module id = 1177
// module chunks = 168707334958949